<app-base-entry-dialog-template [value]="value" [formGroupRef]="formGroupRef" [isSaving]="isSaving"
                                (saveClick)="onSaveClicked()" (cancelClick)="onCancelClicked()">
  <app-job-form
    [(formGroupRef)]="formGroupRef"
    [(value)]="value">
  </app-job-form>
</app-base-entry-dialog-template>
